import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30f16f65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr mb-2" }, null, -1))
const _hoisted_4 = { class: "pd-50" }
const _hoisted_5 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiBsHeader = _resolveComponent("AsahiBsHeader")!
  const _component_BreadcrumbLayout = _resolveComponent("BreadcrumbLayout")!
  const _component_AsahiBsFooter = _resolveComponent("AsahiBsFooter")!
  const _component_AsahiBsNav = _resolveComponent("AsahiBsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AsahiBsHeader, {
        "header-data": _ctx.portalPageMenuLink,
        "cart-item": _ctx.items,
        "favorite-item": _ctx.favoritesItems,
        "cart-number": _ctx.cartItems,
        user: _ctx.user,
        "catalog-permission": _ctx.catalogPermission,
        onRemovefromcart: _cache[0] || (_cache[0] = (event) => _ctx.removeProductFromCart(event?.detail))
      }, null, 8, ["header-data", "cart-item", "favorite-item", "cart-number", "user", "catalog-permission"]),
      _hoisted_3,
      _createElementVNode("main", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_BreadcrumbLayout),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      _createVNode(_component_AsahiBsFooter, {
        onLanguagechange: _ctx.changeLanguage,
        language: _ctx.languages,
        "active-language": _ctx.activeLanguage,
        user: _ctx.user,
        "footer-data": _ctx.portalPageMenuLink,
        "brand-data": _ctx.footerLinksBrands,
        "header-data": _ctx.portalPageMenuLink,
        "footer-copyright-links": _ctx.footerCopyrightLinks
      }, null, 8, ["onLanguagechange", "language", "active-language", "user", "footer-data", "brand-data", "header-data", "footer-copyright-links"]),
      _createVNode(_component_AsahiBsNav, {
        "header-data": _ctx.portalPageMenuLink,
        "right-menu": _ctx.rightMenu,
        "cart-item": _ctx.items,
        "favorite-item": _ctx.favoritesItems,
        "cart-number": _ctx.cartItems,
        user: _ctx.user,
        "catalog-permission": _ctx.catalogPermission,
        onRemovefromcart: _cache[1] || (_cache[1] = (event) => _ctx.removeProductFromCart(event?.detail))
      }, null, 8, ["header-data", "right-menu", "cart-item", "favorite-item", "cart-number", "user", "catalog-permission"])
    ])
  ]))
}